import { deleteRequest, downloadFile, get, patch, post} from 'utils/api';

export const addForm = async (data) => {
  return post('/form', data);
};

export const assignCharger = async (data) => {
  return post('/form/chargers', data);
};

export const fetchChargers = async () => {
  return get('/form/chargers');
};

export const fetchForms = async (data) => {
  return get('/form', data);
};

export const fetchForm = async (formId) => {
  return get('/form/' + formId);
};

export const updateForm = async (data) => {
  return patch('/form/' + data.formId, data.values);
};

export const deleteForm = async (formId) => {
  return deleteRequest('/form/' + formId);
};

//New Items
export const createChecklist = async (data) => {
  return post('/checklist/create', data);
};

export const fetchFromsList = async (data) => {
  return post('/checklist/getAllForms', data);
};

export const fetchStationsOverview = async (data) => {
  return post('/checklist/stations-overview', data);
};

export const fetchStationWiseFroms = async (data) => {
  const stationId = data
  return get(`/checklist/stations/${stationId}`);
};

export const fetchUserStats = async () => {
  return get('/checklist/user-stats');
};

export const submitForm = async (data) => {
  return post('/checklist/forms/submit', data);
};

export const viewForm = async (data) => {
  return post(`/checklist/forms/view/${data.formId}`,data);
};

export const downloadChecklistForm = async (data) => {
  return downloadFile(`/checklist/forms/download/${data.formId}`,data);
};

export const downloadFullPDFByStation = async (data) => {
  return downloadFile(`/checklist/stations/${data.stationId}/full-pdf`, data);
};

export const approveForm = async (data) => {
  return post(`/checklist/forms/changeStatus/${data.formId}`,data);
};

export const deleteChcecklistForm = async (data) => {
  return post(`/checklist/forms/delete/${data.formId}`,data);
};


export const assignToManager = async (data) => {
  return post(`/checklist/forms/assignToManager/${data.formId}`, data);
};

export const assignToContractor = async (data) => {
  return post(`/checklist/forms/assignToContractor/${data.formId}`, data);
};


export const deleteStation = async (stationId) => {
  return post(`/checklist/stations/delete/${stationId}`);
};

export const updateStationDetails = async (stationId, data) => {
  return post(`/checklist/stations/update/${stationId}`, data);
};


export const fetchArchivedForms = async () => {
  return get('/checklist/archived');
};

export const restoreArchivedForm = async (deletedFormId) => {
  return post(`/checklist/archived/restore/${deletedFormId}`);
};

export const fetchPendingApprovals = async () => {
  return get('/checklist/pending-approvals');
};

export const formApi = {
  addForm,
  assignCharger,
  fetchChargers,
  fetchForms,
  fetchForm,
  updateForm,
  deleteForm,
  createChecklist,
  fetchFromsList,
  fetchStationsOverview,
  fetchStationWiseFroms,
  fetchUserStats,
  submitForm,
  viewForm,
  downloadChecklistForm,
  downloadFullPDFByStation,
  approveForm,
  deleteChcecklistForm,
  assignToContractor,
  assignToManager,
  deleteStation,
  updateStationDetails,
  fetchArchivedForms,
  restoreArchivedForm,
  fetchPendingApprovals
};
